import React from 'react';

import TrelloBoard from './containers/TrelloBoard';

const App = () => {
  return (
    <TrelloBoard/>
  );
};

export default App;
